<!-- <app-header position="fixed-top" [showBackButton]="false"></app-header> -->
 <banner-app
  [Fixtop]="''"
  [retroSelected]="true"
  [infoDueno]="true"
  [showPromo]="true"
></banner-app>
<section class="bg-fondo-3 new-vehicle_section spacing-section spacing-top">
    <div class="container h-100">

        <app-details-vehicle-banner></app-details-vehicle-banner>


        <h1 class="my-5 main-title">Cuéntanos sobre tu moto nueva</h1>


        <app-new-vehicle></app-new-vehicle>

    </div>
</section>
<app-footer-app class="footer-fixed" />